<template>
  <div id="app">
    <app-header v-if="currentRoute.name != 'Login'"></app-header>
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import NewHeader from "@/components/Header";
export default {
  components: {
    appHeader: NewHeader,
  },
  data() {
    return {
      currentRoute: "",
    };
  },
  created() {
    this.currentRoute = this.$route;
  },
};
</script>

<style>
@import "./assets/styles/common.css";


html {
  min-height: 100%;
}

body {
  font-family: Open Sans, sans-serif;
  min-height: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  text-align: left;
  color: #525f7f !important;
  background: linear-gradient(
    90deg,
    rgba(254, 87, 46, 1) 0%,
    rgba(255, 146, 63, 1) 100%
  );
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
}

.content-container {
  max-width: 1800px;
  margin: auto;
  padding: 10px;
  /* min-height: 100vh; */
}

.page-header {
  background-color: #b2afab;
  background-position: center center;
  background-size: cover;
  min-height: 100vh;
  max-height: 999px;
  overflow: hidden !important;
  position: relative;
  width: 100%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
